import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import { FaPlay } from "react-icons/fa";

const brandData = [
  { id: 1, img: "/assets/images/brand/brand-thumb-02.png" },
  { id: 2, img: "/assets/images/brand/brand-thumb-03.png" },
  { id: 3, img: "/assets/images/brand/brand-thumb-04.png" },
  { id: 4, img: "/assets/images/brand/brand-thumb-05.png" },
  { id: 5, img: "/assets/images/brand/brand-thumb-06.png" },
  { id: 6, img: "/assets/images/brand/brand-thumb-07.png" },
  { id: 7, img: "/assets/images/brand/brand-thumb-04.png" },
  { id: 8, img: "/assets/images/brand/brand-thumb-05.png" },
];

const Brand = () => {
  return (
    <section
      className="rs-brand-area rs-brand-one section-space-bottom primary-bg rs-swiper"
      style={{ marginTop: "120px" }}
    >
      <div className="container">
        {/* Section Title */}
        <div className="row g-5 section-title-space justify-content-center">
          <div className="col-xl-7 col-lg-7">
            <div className="rs-section-title-wrapper text-center">
              <span className="rs-section-subtitle has-theme-orange">
                <FaPlay color="#EA5501" size={12} />
                Partners
              </span>
              <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                Partners Who Trust Industrie
              </h2>
            </div>
          </div>
        </div>

        {/* Swiper Slider */}
        <div className="row">
          <div className="col-xl-12">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={30}
              slidesPerView={6}
              loop={true}
              autoplay={{ delay: 1500, disableOnInteraction: false }}
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                992: { slidesPerView: 4 },
                1200: { slidesPerView: 6 },
              }}
            >
              {brandData.map((brand) => (
                <SwiperSlide key={brand.id}>
                  <div className="rs-brand-item has-clip-path">
                    <div className="rs-brand-thumb">
                      <img src={brand.img} alt={`Brand ${brand.id}`} />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brand;
